var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.01702C8 7.26855 7.90396 7.52004 7.71229 7.7118L1.67776 13.7463C1.29388 14.1301 0.671503 14.1301 0.287787 13.7463C-0.095929 13.3626 -0.0959291 12.7403 0.287787 12.3564L5.62748 7.01702L0.287973 1.67761C-0.0957431 1.29374 -0.0957431 0.671545 0.287973 0.28786C0.671689 -0.0961972 1.29407 -0.0961972 1.67794 0.28786L7.71248 6.32224C7.90418 6.5141 8 6.76559 8 7.01702Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.bc0dbacf304915ad7789598febbbe880.svg";
export { ForwardRef as ReactComponent };